import { computed, action, extendObservable } from 'mobx';
import axios from '../../../libs/axios_csrf';
import { camelCase, snakeCase } from '@ridi/object-case-converter/dist/index';

export default class TasksStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    extendObservable(this, {
      loading: false,
      boardTasks: {},
    });
  }

  create(title, text, listId, feedbackChain) {
    this.createBackend(title, text, listId, feedbackChain);
  }

  getTasksByBoardId(boardId) {
    if (boardId == undefined) {
      return new Promise((resolve, reject) => resolve([]));
    }
    if (this.boardTasks[boardId] != undefined && !this.dirtyBoardTasks) {
      return new Promise((resolve, reject) =>
        resolve(this.boardTasks[boardId]),
      );
    } else {
      return this.fetchTasks(boardId)
        .then(tasks => {
          return tasks;
        })
        .catch(err => {
          return [];
        });
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // BACKEND CONNECTIONS
  @action
  createBackend(title, text, listId, feedbackChain) {
    if (this.rootStore.authorizationsStore.canCreateTask()) {
      this.loading = true;
      axios
        .post('/cards.json', {
          card: {
            list_id: listId,
            name: title,
            description: text,
            priority: feedbackChain.priority,
            assignee_id:
              feedbackChain.assignees.length >= 1
                ? feedbackChain.assignees[0].id
                : null,
            cards_memberships_attributes: feedbackChain.assignees.map(a => ({
              user_id: a.id,
            })),
          },
        })
        .then(
          action(response => {
            this.loading = false;
            const task = camelCase(response.data, true);
            feedbackChain.setCardId(task.id);
            if (!this.boardTasks[task.board.id]) {
              this.boardTasks[task.board.id] = [];
            }
            this.boardTasks[task.board.id].push(task);
            this.fetchTasks(task.board.id);
          }),
        )
        .catch(
          action(error => {
            console.log(error);
          }),
        );
    }
  }

  @action
  fetchTasks(boardId) {
    if (this.rootStore.authorizationsStore.canFetchTasks()) {
      this.loading = true;
      return axios
        .get('/feedback_chains/feedback_tasks', {
          params: { board_id: boardId },
        })
        .then(
          action(response => {
            this.boardTasks[boardId] = camelCase(response.data.tasks, true);
            this.loading = false;
            return this.boardTasks[boardId];
          }),
        )
        .catch(
          action(error => {
            this.loading = false;
            return new Promise((resolve, reject) => {
              reject('Error fetching tasks');
            });
          }),
        );
    }
    return new Promise((resolve, reject) => {
      reject('Not authorized');
    });
  }
  // end BACKEND CONNECTIONS
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}
